import { checkEnterpriseId, getResponseData } from "@helpers/_functions";
import BaseService from "./base.service";
import http from "../http-common";

class AdditionalInformationService extends BaseService {
  constructor() {
    super("additional-information");
  }

  getAdditionalInformation(enterpriseId) {
    enterpriseId = checkEnterpriseId(enterpriseId);
    return http
      .get(`${this.path}/get/${enterpriseId}`)
      .then((response) => getResponseData(response));
  }
}

export default new AdditionalInformationService();